var _path, _mask, _path2, _path3, _path4, _path5, _mask2, _path6, _path7, _path8, _circle, _circle2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 125,
    viewBox: "0 0 116 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0072 7.90253H83.6178L106.775 31.0602V78.8902C106.775 80.5106 106.132 82.0647 104.986 83.2105C103.84 84.3563 102.286 85 100.666 85H52.0072C50.3868 85 48.8328 84.3563 47.687 83.2105C46.5412 82.0647 45.8975 80.5106 45.8975 78.8902V14.0123C45.8975 12.3919 46.5412 10.8378 47.687 9.69203C48.8328 8.54623 50.3868 7.90253 52.0072 7.90253Z",
    fill: "#F0F6FF",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_110_18716",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4463 5.90259V30.2318H108.776"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4463 5.90259V30.2318H108.776",
    fill: "#F0F6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4463 5.90259C88.4463 3.69345 86.6554 1.90259 84.4463 1.90259C82.2371 1.90259 80.4463 3.69345 80.4463 5.90259H88.4463ZM84.4463 30.2318H80.4463C80.4463 32.441 82.2371 34.2318 84.4463 34.2318V30.2318ZM108.776 34.2318C110.985 34.2318 112.776 32.441 112.776 30.2318C112.776 28.0227 110.985 26.2318 108.776 26.2318V34.2318ZM80.4463 5.90259V30.2318H88.4463V5.90259H80.4463ZM84.4463 34.2318H108.776V26.2318H84.4463V34.2318Z",
    fill: "white",
    mask: "url(#path-2-inside-1_110_18716)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5559 50.5062H60.1169",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5559 66.7257H60.1169",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_110_18716",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2267 34.2864H64.1718H60.1169"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2267 34.2864H64.1718H60.1169",
    fill: "#F0F6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2267 38.2864C70.4358 38.2864 72.2267 36.4956 72.2267 34.2864C72.2267 32.0773 70.4358 30.2864 68.2267 30.2864V38.2864ZM60.1169 30.2864C57.9078 30.2864 56.1169 32.0773 56.1169 34.2864C56.1169 36.4956 57.9078 38.2864 60.1169 38.2864V30.2864ZM68.2267 30.2864H64.1718V38.2864H68.2267V30.2864ZM64.1718 30.2864H60.1169V38.2864H64.1718V30.2864Z",
    fill: "white",
    mask: "url(#path-6-inside-2_110_18716)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0072 8.18219H83.6219L106.776 31.1762V78.6667C106.776 80.2678 106.135 81.8061 104.991 82.9425C103.846 84.0794 102.291 84.7205 100.666 84.7205H52.0072C50.3824 84.7205 48.8268 84.0793 47.6821 82.9425C46.5378 81.8061 45.8975 80.2678 45.8975 78.6667V14.236C45.8975 12.6349 46.5378 11.0966 47.6821 9.9602C48.8268 8.82334 50.3824 8.18219 52.0072 8.18219Z",
    fill: "#F0F6FF",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7146,
    cy: 22.7855,
    r: 6.21239,
    transform: "rotate(28.6766 20.7146 22.7855)",
    fill: "#DBE9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4381,
    cy: 27.2964,
    r: 1.5531,
    fill: "#F0F6FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6195 5.0354H51.4868C49.29 5.0354 47.1831 5.90809 45.6297 7.46149C44.0763 9.01489 43.2036 11.1217 43.2036 13.3186V79.5841C43.2036 81.7809 44.0763 83.8878 45.6297 85.4412C47.1831 86.9946 49.29 87.8673 51.4868 87.8673H101.186C103.383 87.8673 105.49 86.9946 107.043 85.4412C108.596 83.8878 109.469 81.7809 109.469 79.5841V29.885L84.6195 5.0354Z",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6196 5.0354V29.885H109.469",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9028 50.5929H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9028 67.1593H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0532 34.0266H63.9116H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6195 5.0354H51.4868C49.29 5.0354 47.1831 5.90809 45.6297 7.46149C44.0763 9.01489 43.2036 11.1217 43.2036 13.3186V79.5841C43.2036 81.7809 44.0763 83.8878 45.6297 85.4412C47.1831 86.9946 49.29 87.8673 51.4868 87.8673H101.186C103.383 87.8673 105.49 86.9946 107.043 85.4412C108.596 83.8878 109.469 81.7809 109.469 79.5841V29.885L84.6195 5.0354Z",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9028 50.5929H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9028 67.1593H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0532 34.0266H63.9116H59.77",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6196 5.0354V29.885H109.469",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1756 11.7522C29.1075 12.539 26.7936 11.5004 26.0068 9.43221C25.2189 7.36406 26.2586 5.05016 28.3267 4.26335C30.3949 3.47553 32.7088 4.51517 33.4956 6.58332C34.2824 8.65147 33.2438 10.9654 31.1756 11.7522Z",
    fill: "#F0F6FF",
    stroke: "#DBE9FF",
    strokeWidth: 3.0244,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7346 119C95.7346 121.209 79.8412 123 60.2352 123C40.6291 123 24.7346 121.209 24.7346 119C24.7346 116.791 40.6291 115 60.2352 115C79.8412 115 95.7346 116.791 95.7346 119Z",
    fill: "#DBE9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_18716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2648 39.5364V68.3796L64.5226 90.3485C65.3633 91.4123 65.8869 92.6916 66.0336 94.0395C66.1802 95.3875 65.9438 96.7494 65.3515 97.9691C64.7592 99.1887 63.8351 100.217 62.6851 100.935C61.5352 101.653 60.206 102.033 58.8501 102.03H16.4506C15.0947 102.033 13.7655 101.653 12.6156 100.935C11.4656 100.217 10.5415 99.1887 9.94919 97.9691C9.35692 96.7494 9.12053 95.3875 9.26714 94.0395C9.41375 92.6916 9.93742 91.4123 10.7781 90.3485L28.0359 68.3796V39.5364M20.8251 39.5364H54.4756H20.8251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2648 39.5364V68.3796L64.5226 90.3485C65.3633 91.4124 65.8869 92.6916 66.0336 94.0395C66.1802 95.3875 65.9438 96.7494 65.3515 97.9691C64.7592 99.1887 63.8351 100.217 62.6851 100.935C61.5352 101.653 60.206 102.033 58.8501 102.03H16.4506C15.0947 102.033 13.7655 101.653 12.6156 100.935C11.4656 100.217 10.5415 99.1887 9.94919 97.9691C9.35692 96.7494 9.12053 95.3875 9.26714 94.0395C9.41375 92.6916 9.93742 91.4124 10.7781 90.3485L28.0359 68.3796V39.5364M20.8251 39.5364H54.4756",
    stroke: "#0161FE",
    strokeWidth: 3.10619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_18716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.3009,
    height: 67.3009,
    fill: "white",
    transform: "translate(4 37.1328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.7698afee186eb205db12ad1d30fccb24.svg";
export { ForwardRef as ReactComponent };